// Importing React and necessary libraries
import React from "react";
import { FronteggProvider } from "@frontegg/react";
import { SnackbarProvider } from "notistack"; // For displaying notifications
import { Provider } from "react-redux"; // For integrating Redux
import { BrowserRouter } from "react-router-dom"; // For routing
import * as moment from "moment-timezone"; // For handling time zones
import { store } from "./Redux/store"; // Redux store
import AuthBootstrap from "./AuthBootstrap";

// Importing core components and styles
import "./assets/css/material-dashboard-react.css"; // Custom CSS for the app
import AppView from "./AppView"; // Component for the invite view

// Setting the default timezone based on the user's local timezone
const localtz = moment.tz.guess();
moment.tz.setDefault(localtz);

const contextOptions = {
  baseUrl: process.env.REACT_APP_FRONTEGG_APP_URL,
  clientId: process.env.REACT_APP_FRONTEGG_CLIENT_ID,
  appId: process.env.REACT_APP_FRONTEGG_VTPORTAL_APP_ID,
};

const authOptions = {
  keepSessionAlive: true,
};

// Main App component
const App = () => (
  <BrowserRouter>
    {/* SnackbarProvider for managing notifications */}
    <SnackbarProvider
      maxSnack={3} // Maximum number of snackbars displayed at once
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }} // Snackbar position
      preventDuplicate // Prevent duplicate notifications
      autoHideDuration={2500} // Auto-hide duration for notifications
    >
      {/* Redux Provider to make the store available to the app */}
      <Provider store={store}>
        <FronteggProvider
          contextOptions={contextOptions}
          hostedLoginBox
          authOptions={authOptions}
        >
          <AuthBootstrap>
            <AppView />
          </AuthBootstrap>
        </FronteggProvider>
      </Provider>
    </SnackbarProvider>
  </BrowserRouter>
);

export default App; // Exporting the App component as the default export
